import React, { forwardRef, memo, useId, useMemo } from "react"
import styled from "styled-components"
import { ICONS } from "@repo/utils/constants"
import dynamic from "next/dynamic"
import useColor from "../../../hooks/useColor"
const List = dynamic(() => import("./SVGR").then((mod) => mod.List), { ssr: false })
const Tiles = dynamic(() => import("./SVGR").then((mod) => mod.Tiles), { ssr: false })
const Wave = dynamic(() => import("./SVGR").then((mod) => mod.Wave), { ssr: false })
const SharpWave = dynamic(() => import("./SVGR").then((mod) => mod.SharpWave), { ssr: false })
const CircularWave = dynamic(() => import("./SVGR").then((mod) => mod.CircularWave), { ssr: false })
const MediumWave = dynamic(() => import("./SVGR").then((mod) => mod.MediumWave), { ssr: false })
const HighWave = dynamic(() => import("./SVGR").then((mod) => mod.HighWave), { ssr: false })
const WavyCircle = dynamic(() => import("./SVGR").then((mod) => mod.WavyCircle), { ssr: false })
const ArrowUp = dynamic(() => import("./SVGR").then((mod) => mod.ArrowUp), { ssr: false })
const ArrowDown = dynamic(() => import("./SVGR").then((mod) => mod.ArrowDown), { ssr: false })
const ArrowRight = dynamic(() => import("./SVGR").then((mod) => mod.ArrowRight), { ssr: false })
const PleoniansRecruit = dynamic(() => import("./SVGR").then((mod) => mod.PleoniansRecruit), { ssr: false })
const PleoDesignLogo = dynamic(() => import("./SVGR").then((mod) => mod.PleoDesignLogo), { ssr: false })
const PleoDigitalLogo = dynamic(() => import("./SVGR").then((mod) => mod.PleoDigitalLogo), { ssr: false })
const PleoMethodLogo = dynamic(() => import("./SVGR").then((mod) => mod.PleoMethodLogo), { ssr: false })
const PleoExpoLogo = dynamic(() => import("./SVGR").then((mod) => mod.PleoExpoLogo), { ssr: false })
const PleoGroupLogo = dynamic(() => import("./SVGR").then((mod) => mod.PleoGroupLogo), { ssr: false })
const HomeLine = dynamic(() => import("./SVGR").then((mod) => mod.HomeLine), { ssr: false })
const Rocket = dynamic(() => import("./SVGR").then((mod) => mod.Rocket), { ssr: false })
const HowWeCreateStoryArrowDownDesktop = dynamic(() => import("./SVGR").then((mod) => mod.HowWeCreateStoryArrowDownDesktop), { ssr: false })
const HowWeCreateStoryArrowDownMobile = dynamic(() => import("./SVGR").then((mod) => mod.HowWeCreateStoryArrowDownMobile), { ssr: false })
const WeArePleoniansTag = dynamic(() => import("./SVGR").then((mod) => mod.WeArePleoniansTag), { ssr: false })
const ArrowButtonRight = dynamic(() => import("./SVGR").then((mod) => mod.ArrowButtonRight), { ssr: false })
const ArrowButtonLeft = dynamic(() => import("./SVGR").then((mod) => mod.ArrowButtonLeft), { ssr: false })
const ServiceCirclePartBorder = dynamic(() => import("./SVGR").then((mod) => mod.ServiceCirclePartBorder), { ssr: false })
const AreasOfExpertisePieceOfCircle = dynamic(() => import("./SVGR").then((mod) => mod.AreasOfExpertisePieceOfCircle), { ssr: false })
const LongThinArrowLeft = dynamic(() => import("./SVGR").then((mod) => mod.LongThinArrowLeft), { ssr: false })
const LongThinArrowRight = dynamic(() => import("./SVGR").then((mod) => mod.LongThinArrowRight), { ssr: false })
const ShortThinArrowLeft = dynamic(() => import("./SVGR").then((mod) => mod.ShortThinArrowLeft), { ssr: false })
const ShortThinArrowRight = dynamic(() => import("./SVGR").then((mod) => mod.ShortThinArrowRight), { ssr: false })
const Cross = dynamic(() => import("./SVGR").then((mod) => mod.Cross), { ssr: false })
const PleoDesignLogoMenu = dynamic(() => import("./SVGR").then((mod) => mod.PleoDesignLogoMenu), { ssr: false })
const PleoGroupLogoMenu = dynamic(() => import("./SVGR").then((mod) => mod.PleoGroupLogoMenu), { ssr: false })
const FeaturedProjects = dynamic(() => import("./SVGR").then((mod) => mod.FeaturedProjects), { ssr: false })
const FeaturedProjectsPL = dynamic(() => import("./SVGR").then((mod) => mod.FeaturedProjectsPL), { ssr: false })
const SoundOn = dynamic(() => import("./SVGR").then((mod) => mod.SoundOn), { ssr: false })
const SoundOff = dynamic(() => import("./SVGR").then((mod) => mod.SoundOff), { ssr: false })
const Preloader = dynamic(() => import("./SVGR").then((mod) => mod.Preloader), { ssr: false })
const ThickWave = dynamic(() => import("./SVGR").then((mod) => mod.ThickWave), { ssr: false })
const SoonMask = dynamic(() => import("./SVGR").then((mod) => mod.SoonMask), { ssr: false })
const OpenInNewWindowModal = dynamic(() => import("./SVGR").then((mod) => mod.OpenInNewWindowModal), { ssr: false })
const X = dynamic(() => import("./SVGR").then((mod) => mod.X), { ssr: false })
const Copy = dynamic(() => import("./SVGR").then((mod) => mod.Copy), { ssr: false })
const Facebook = dynamic(() => import("./SVGR").then((mod) => mod.Facebook), { ssr: false })
const LinkedIn = dynamic(() => import("./SVGR").then((mod) => mod.LinkedIn), { ssr: false })
const ShareIcon = dynamic(() => import("./SVGR").then((mod) => mod.ShareIcon), { ssr: false })

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 100%;
	height: 100%;
	max-width: 100px;
	&.areas-of-expertise-delay {
		svg {
			path,
			circle {
				transition: all var(--color-transition-duration) var(--ease);
			}
		}
	}
	svg {
		display: block;
		width: 100%;
		height: 100%;
		path,
		circle {
			transition: all var(--color-transition-duration) var(--ease);
			pointer-events: none;
		}
	}

	&:not(&.no-color) {
		svg {
			path,
			circle {
				fill: ${({ $color }) => $color || "var(--secondary-color)"};
			}
		}
	}
`

const SVGR = ({ name, ...props }) => {
	switch (name) {
		case ICONS.LIST:
			return <List {...props} />
		case ICONS.TILES:
			return <Tiles {...props} />
		case ICONS.WAVE:
			return <Wave {...props} />
		case ICONS.SHARPWAVE:
			return <SharpWave {...props} />
		case ICONS.CIRCULARWAVE:
			return <CircularWave {...props} />
		case ICONS.MEDIUMWAVE:
			return <MediumWave {...props} />
		case ICONS.HIGHWAVE:
			return <HighWave {...props} />
		case ICONS.ARROWUP:
			return <ArrowUp {...props} />
		case ICONS.ARROWDOWN:
			return <ArrowDown {...props} />
		case ICONS.ARROWRIGHT:
			return <ArrowRight {...props} />
		case ICONS.PLEONIANSRECRUIT:
			return <PleoniansRecruit {...props} />
		case ICONS.PLEO_LOGO_DESIGN:
			return <PleoDesignLogo {...props} />
		case ICONS.PLEO_LOGO_DIGITAL:
			return <PleoDigitalLogo {...props} />
		case ICONS.PLEO_LOGO_METHOD:
			return <PleoMethodLogo {...props} />
		case ICONS.PLEO_LOGO_EXPO:
			return <PleoExpoLogo {...props} />
		case ICONS.PLEO_LOGO_GROUP:
			return <PleoGroupLogo {...props} />
		case ICONS.WAVY_CIRCLE:
			return <WavyCircle {...props} />
		case ICONS.HOME_LINE:
			return <HomeLine {...props} />
		case ICONS.ROCKET:
			return <Rocket {...props} />
		case ICONS.HOW_WE_CREATE_STORY_ARROW_DOWN_DESKTOP:
			return <HowWeCreateStoryArrowDownDesktop {...props} />
		case ICONS.HOW_WE_CREATE_STORY_ARROW_DOWN_MOBILE:
			return <HowWeCreateStoryArrowDownMobile {...props} />
		case ICONS.WE_ARE_PLEONIANS_TAG:
			return <WeArePleoniansTag {...props} />
		case ICONS.BUTTON_ARROW_RIGHT:
			return <ArrowButtonRight {...props} />
		case ICONS.BUTTON_ARROW_LEFT:
			return <ArrowButtonLeft {...props} />
		case ICONS.SERVICE_CIRCLE_PART_BORDER:
			return <ServiceCirclePartBorder {...props} />
		case ICONS.AREAS_OF_EXPERTISE_PIECE:
			return <AreasOfExpertisePieceOfCircle {...props} />
		case ICONS.LONG_THIN_ARROW_LEFT:
			return <LongThinArrowLeft {...props} />
		case ICONS.LONG_THIN_ARROW_RIGHT:
			return <LongThinArrowRight {...props} />
		case ICONS.SHORT_THIN_ARROW_LEFT:
			return <ShortThinArrowLeft {...props} />
		case ICONS.SHORT_THIN_ARROW_RIGHT:
			return <ShortThinArrowRight {...props} />
		case ICONS.CROSS:
			return <Cross {...props} />
		case ICONS.PLEO_DESIGN_MENU_LOGO:
			return <PleoDesignLogoMenu {...props} />
		case ICONS.PLEO_GROUP_MENU_LOGO:
			return <PleoGroupLogoMenu {...props} />
		case ICONS.FEATURED_PROJECTS:
			return <FeaturedProjects {...props} />
		case ICONS.FEATURED_PROJECTS_PL:
			return <FeaturedProjectsPL {...props} />
		case ICONS.SOUND_ON:
			return <SoundOn {...props} />
		case ICONS.SOUND_OFF:
			return <SoundOff {...props} />
		case ICONS.PRELOADER:
			return <Preloader {...props} />
		case ICONS.THICK_WAVE:
			return <ThickWave {...props} />
		case ICONS.SOON_MASK:
			return <SoonMask {...props} />
		case ICONS.OPEN_IN_NEW_WINDOW_MODAL:
			return <OpenInNewWindowModal {...props} />
		case ICONS.X:
			return <X {...props} />
		case ICONS.COPY:
			return <Copy {...props} />
		case ICONS.LINKEDIN:
			return <LinkedIn {...props} />
		case ICONS.FACEBOOK:
			return <Facebook {...props} />
		case ICONS.SHARE_ICON:
			return <ShareIcon {...props} />
		default:
			return null
	}
}

const Icon = forwardRef(function Icon({ id = "", name = "", color = "secondary", className = "", children, svgProps, ...props }, ref) {
	const reactId = useId()
	const uuid = useMemo(() => id || reactId, [id]) //use passed id or generate one
	const standardizedId = `icon-${name}-${uuid}`.replaceAll("/--|- -/g", "-") //replace "--" or "- -" with "-"
	const cl = useColor(color)
	return (
		<Wrapper ref={ref} id={standardizedId} $color={cl} className={`${className} ${name} icon`} {...props}>
			<SVGR name={name} {...svgProps} />
			{children}
		</Wrapper>
	)
})

export default memo(Icon)
